import { useState } from 'react';

import { UserMin } from '@apiContract';

type Props = {
  selected?: UserMin;
};

export const useSingleSelectUsers = ({ selected }: Props) => {
  const [selectedUser, setSelectedUser] = useState<UserMin | null>(selected || null);

  const onUserClick = (user: UserMin) => {
    setSelectedUser(user);
  };

  const onDeleteUser = () => {
    setSelectedUser(null);
  };

  return {
    selectedUser,
    onUserClick,
    onDeleteUser,
  };
};
